import io from 'socket.io-client';
import { BaseSocketUrl } from '../Constants/Until';

const SocketCall = io(BaseSocketUrl, {
  forceNew: true,
  secure: false,
});

export default SocketCall;